import NotasNivel1 from '../../produto/spa/notas/NotasNivel1';

export default NotasNivel1;
